import React, {useState} from 'react'
import {useForm} from "react-hook-form";

const MacGenerateServiceID = ({ prevStep, nextStep, handleChange, values }) => {
    const [num, setNum] = useState(0);
    const {
        register,
        formState: { errors }
    } = useForm();

    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const handleClick = () => {
        setNum(randomNumberInRange(9999, 999999));
    };


    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <h5 className="tbsub-title mt-3 mb-3">Step 1 of 4</h5>
                <form>
                    <div className="col-md-12">
                        <div className="form-group row">
                            <label className="control-label col-md-4"> Click 'Generate' to create a new Service ID:</label>
                            <input type="text" {...register("firstName", { required: true, maxLength: 200 })} value={num}
                                   style={{ ...styles.input, borderColor: errors.firstName && "red",marginRight:"50px" }} onChange={handleChange('firstName')}
                                   className="form-control form-control-sm col-md-3" />
                            <button className="btn btn-primary col-md-3"
                                    type="button" style={{padding:"3px 10px 3px"}}
                                    onClick={() => handleClick()}
                                    value="Generate"
                            >Generate</button>
                        </div>
                    </div>
                    <button onClick={ Continue }
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="btn btn-primary"
                    >Next</button>
                </form>
            </div>
        </div>
    )
}

export default MacGenerateServiceID